import { AbstractControl, FormGroup } from '@angular/forms';
import { ValidatorMessageModel } from './validator-message.model';
import { TranslationHelper } from '../../../../client/core/lib/translation.helper';

export class Validation extends TranslationHelper {
  private _wasValidated = false;

  public get wasValidated() {
    return this._wasValidated;
  }

  public validateControl(formControl: AbstractControl): boolean {
    return !formControl.valid && this.wasValidated;
  }

  public getValidationMessages(
    formControl: AbstractControl
  ): ValidatorMessageModel[] | null {
    if (this.validateControl(formControl) && formControl.errors) {
      const errorsMessages: ValidatorMessageModel[] = [];
      for (const key of Object.keys(formControl.errors)) {
        const error = formControl.errors[key];

        if (error.message) {
          errorsMessages.push(error);
        }
      }
      return errorsMessages;
    }
    return null;
  }

  public getValidationMessagesOfForm(
    form: FormGroup
  ): ValidatorMessageModel[] | null {
    if (this.validateForm(form) && form.errors) {
      const errorsMessages: ValidatorMessageModel[] = [];
      for (const key of Object.keys(form.errors)) {
        const error = form.errors[key];

        if (error.message) {
          errorsMessages.push(error);
        }
      }
      return errorsMessages;
    }
    return null;
  }

  public validateForm(form: FormGroup): boolean {
    return !form.valid && this.wasValidated;
  }

  public triggerWasValidated() {
    this._wasValidated = true;
  }

  public resetWasValidated() {
    this._wasValidated = false;
  }
}
